// extracted by mini-css-extract-plugin
module.exports = {"medal":"_3-I3DL","place-1":"_1-_shw","place-2":"_10mUb3","place-3":"_2SUgpI","prize":"_3LfG0q"};